import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import RequestModal from "../components/RequestModal";
import { useSettings } from "../context/SettingsContext";

function Shell({ children }) {
  const [req, setReq] = useState(false);
  return (
    <div className="sk">
      <Navbar onRequest={() => setReq(true)} />
      <main><section className="block wrap"><div className="legal">{children}</div></section></main>
      <Footer />
      {req ? <RequestModal onClose={() => setReq(false)} /> : null}
    </div>
  );
}

export function HowItWorksPage() {
  return (
    <div className="sk">
      <Navbar />
      <main>
        <section className="block wrap">
          <div className="shead"><div><h2>How it works</h2><p>From enquiry to take-off, we handle the details.</p></div></div>
          <ol className="steps">
            <li><h3>Tell us your trip</h3><p>Route, date and number of guests. Search on the home page or send a request.</p></li>
            <li><h3>Get options and a quote</h3><p>We check available aircraft with licensed operators and send you an itemised quote.</p></li>
            <li><h3>Confirm and pay</h3><p>We lock the aircraft, collect passenger details and arrange permits and ground transport.</p></li>
            <li><h3>Fly</h3><p>Arrive shortly before departure at the private terminal and board. We stay on call until you land.</p></li>
          </ol>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export function AboutPage() {
  const s = useSettings();
  return (
    <Shell>
      <h1>About {s.brand}</h1>
      <p>{s.brand} is an air charter broker based in India. We arrange private flights on your behalf: jets, turboprops and helicopters for business travel, weddings, pilgrimages, campaigns, medical transfers and cargo.</p>
      <p>We do not own or operate aircraft. Every flight we arrange is operated by an operator holding a Non-Scheduled Operator Permit issued by India's Directorate General of Civil Aviation (DGCA), which retains full operational control of the aircraft and crew.</p>
      <h2>How we earn</h2>
      <p>We work on a commission basis. You tell us your trip, we obtain quotes from licensed operators, and we present you clear options. Our fee is built into the quote you approve — there are no hidden charges.</p>
      <h2>Why book through us</h2>
      <p>We know the Indian charter market: which aircraft suit which routes, which strips they can reach, and how to plan pilgrimage and high-altitude sectors. You get one point of contact from enquiry to landing.</p>
    </Shell>
  );
}

export function ContactPage() {
  const s = useSettings();
  return (
    <Shell>
      <h1>Contact us</h1>
      <p>Tell us your route, date and number of guests and we'll come back with aircraft options and a quote.</p>
      <h2>Reach us</h2>
      <p>
        {s.phone ? <>Phone: <a href={`tel:${s.phone}`}>{s.phone}</a><br /></> : <>Phone: to be updated<br /></>}
        {s.email ? <>Email: <a href={`mailto:${s.email}`}>{s.email}</a><br /></> : <>Email: to be updated<br /></>}
        {s.whatsapp ? <>WhatsApp: <a href={`https://wa.me/${s.whatsapp.replace(/\D/g, "")}`} target="_blank" rel="noopener noreferrer">{s.whatsapp}</a><br /></> : <>WhatsApp: to be updated<br /></>}
        {s.city ? <>Based in: {s.city}</> : null}
      </p>
      <p>You can also use the “Request a flight” button on any page to send us your trip details directly.</p>
    </Shell>
  );
}

export function PrivacyPage() {
  const s = useSettings();
  return (
    <Shell>
      <h1>Privacy Policy</h1>
      <p>This policy explains how {s.brand} handles the information you share when you request a flight.</p>
      <h2>What we collect</h2>
      <p>When you submit a request we collect your name, phone number, optional email, and the trip details you provide (route, date, passengers and any notes). We use this only to prepare quotes and arrange your flight.</p>
      <h2>How we use it</h2>
      <p>We share the minimum necessary trip details with licensed operators to obtain quotes. We never sell your data. We keep records of your enquiry so we can serve you and meet legal requirements.</p>
      <h2>Your choices</h2>
      <p>You may ask us to update or delete your details at any time by contacting us. By submitting a request you consent to being contacted about that request.</p>
    </Shell>
  );
}

export function TermsPage() {
  const s = useSettings();
  return (
    <Shell>
      <h1>Terms of Service</h1>
      <h2>Our role</h2>
      <p>{s.brand} acts as an air charter broker and arranges flights as your agent. We are not an air operator. Each flight is operated by a DGCA-licensed Non-Scheduled Operator that has operational control of the aircraft.</p>
      <h2>Quotes and availability</h2>
      <p>All aircraft, prices and times shown on this site are indicative. Seats, range and flight times vary with layout, load and weather. Every trip is subject to aircraft availability and a confirmed written quote.</p>
      <h2>Payments and cancellations</h2>
      <p>Booking terms, payment schedules and cancellation charges are set out in the quote you approve for each trip.</p>
      <h2>Liability</h2>
      <p>As a broker, our liability is limited to arranging the flight. The operating airline is responsible for the conduct of the flight and carriage of passengers and baggage.</p>
    </Shell>
  );
}
